// extracted by mini-css-extract-plugin
export default {"ieAlert":"Pt4537rCcUa6dxJmepSF","messageContainer":"KuTRByoVKwkKFKEuBd0l","ieIcon":"G_CuivuRH1rgsu6aUqDW","ieText":"sE3W3KKrxv27IsPEQIZs","closeIeAlert":"Z86NgZwNQR_cujb3fGdN"};